export const PERM = {
  SUPERVISOR_LIST: "view_supervisor",
  SUPERVISOR_CREATE: "add_supervisor",
  SUPERVISOR_UPDATE: "change_supervisor",
  SUPERVISOR_DELETE: "delete_supervisor",
  SUPERVISOR_DEPOSIT: "deposit_supervisor",
  SUPERVISOR_WITHDRAW: "withdraw_supervisor",

  VENDOR_LIST: "view_vendor",
  VENDOR_CREATE: "add_vendor",
  VENDOR_UPDATE: "change_vendor",
  VENDOR_DELETE: "delete_vendor",
  VENDOR_DEPOSIT: "deposit_vendor",
  VENDOR_WITHDRAW: "withdraw_vendor",

  TICKET_LIST: "view_salesticket",
  TICKET_SALE: "view_salesticket",
  TICKET_EDIT: "change_ticket",
  TICKET_CANCEL: "cancel_ticket",

  REPORT_SALE: "view_salesreport",
  COMMISSION_PAY: "add_commissionpayment",
  TRANSACTIONS_LIST: "view_transaction_all",

  CONFIG_EXCHANGE_RATE_VIEW: "view_exchangerate",
  CONFIG_EXCHANGE_RATE_ADD: "add_exchangerate",
  CONFIG_EXCHANGE_RATE_CHANGE: "change_exchangerate",
  CONFIG_EXCHANGE_RATE_DELETE: "delete_exchangerate",

  CONFIG_FEE_VIEW: "view_fee",
  CONFIG_FEE_ADD: "add_fee",
  CONFIG_FEE_CHANGE: "change_fee",
  CONFIG_FEE_DELETE: "delete_fee",

  CONFIG_USER_COMMISSION_VIEW: "view_usercommission",
  CONFIG_USER_COMMISSION_ADD: "add_usercommission",
  CONFIG_USER_COMMISSION_CHANGE: "change_usercommission",
  CONFIG_USER_COMMISSION_DELETE: "delete_usercommission",

  CONFIG_LIMIT_GENERAL_VIEW: "view_limittransactiongenerale",
  CONFIG_LIMIT_GENERAL_ADD: "add_limittransactiongenerale",
  CONFIG_LIMIT_GENERAL_CHANGE: "change_limittransactiongenerale",
  CONFIG_LIMIT_GENERAL_DELETE: "delete_limittransactiongenerale",
};
